module.exports = __webpack_public_path__ + "img/bg.3e3c4ca7.png";